export const AUTH_ENDPOINTS = {
  SIGN_UP: '/users/v2/',
  
  SIGN_UP_VERIFY: '/users/v2/verify',
  
  LOGIN: '/users/v2/sessions',
  
  LOGIN_VERIFY: '/users/v2/sessions/verify',

  LOGIN_WITH_EMAIL_PASSWORD: '/users/sign_in',

  SIGN_OUT: '/users/sign_out'
};

export default AUTH_ENDPOINTS;
